import { render, staticRenderFns } from "./preview.vue?vue&type=template&id=67c38b50&"
import script from "./preview.vue?vue&type=script&lang=js&"
export * from "./preview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports